<template src="./login-initial.html"></template>

<script>
import Vue from 'vue'
import { EventBus } from '@/router/bus'
import AlertContainer from '@/components/header/alert-container/AlertContainer.vue'
import { validationMixin } from '@/mixins/validation'
import { required, minLength, maxLength } from 'vuelidate/lib/validators'

export default {
  name: 'login-initial',
  mixins: [validationMixin],
  components: { AlertContainer },
  data () {
    return {
      loading: false,
      tabs: null,
      user: {
        login: '',
        password: ''
      }
    }
  },
  computed: {
    loginErrors () {
      return !this.$v.user.login.$dirty ? [] : this.getUserValidationErrorsByName('login')
    }
  },
  methods: {
    getUserValidationErrorsByName (name) {
      return this.getValidationErrors('user').filter((x) => { return x.field === name }).map(x => x.msg)
    },
    validateBeforeSubmit () {
      this.$v.$touch()
      if (this.$v.user.$anyError || this.loading) {
        return
      }

      this.initialLogin()
    },
    initialLogin () {
      this.loading = true
      this.logConsole('Sending initial login request')
      this.$http.put(Vue.$apiConfig.activateRegisteredUserPost.replace('{login}', this.user.login))
        .then(response => {
          this.logConsole(response)
          this.loading = false
          this.user.login = null
          EventBus.$emit('alert', {
            variant: 'success',
            message: this.$t('activation.activationSent'),
            errors: []
          })
        }, error => {
          this.logConsole(error)
          this.loading = false
          this.formatErrorResponse(error)
        })
    }
  },
  validations: {
    user: {
      login: {
        required,
        minLength: minLength(4),
        maxLength: maxLength(32)
      }
    }
  }
}
</script>
